// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import './assets/css/reset.css'
import element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import './icons'
// require styles
import 'swiper/dist/css/swiper.css'

import Dialog from './components/Dialog'
import BaiduMap from 'vue-baidu-map'

import ba from 'vue-ba'
import Video from 'video.js'
import 'video.js/dist/video-js.css'

Vue.prototype.$video = Video
let url = decodeURIComponent(window.location.href)
let tId = ''
if (url.indexOf('tripolers.com.cn/') > -1) {
  tId = 'd3a0c4a0952a89e1f08dd03e626382b5'
} else if ((url.indexOf('tripolers.com/') > -1)) {
  if (url.indexOf('a.tripolers.com/') > -1) {
    tId = '6c54f491b9aa2789b8f9d37a55e0be7a'
  } else {
    tId = '1b000e1f73937d879fccdb635b6d8b44'
  }
}
Vue.use(BaiduMap, {
  ak: 'xz9aTCnGQc2S4cyxIkGzMHkew3zE0Qu6'
})
Vue.use(ba, tId)
Vue.use(ba, { siteId: tId })

Vue.prototype.$dialog = Dialog

Vue.use(VueAwesomeSwiper)

Vue.use(element)
Vue.config.productionTip = false

// 路由跳转前回到顶部
router.beforeEach((to, from, next) => {
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js